import axios from 'axios';

//https://localhost:44305
const resolveBaseURL = () => {
  try {
    const { hostname, origin } = window.location;
    if (hostname.includes('localhost')) {
      // Announcements service local default
      return 'https://adminrotary.codiatest.com/';
    }
    // Ensure origin ends with '/'
    return origin.endsWith('/') ? origin : `${origin}/`;
  } catch (e) {
    return 'https://adminrotary.codiatest.com/';
  }
};

export const httpClientAnnouncements = axios.create({
  baseURL: resolveBaseURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json, text/plain',
  },
  withCredentials: true,
});

httpClientAnnouncements.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth.token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

httpClientAnnouncements.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export const resolveAnnouncementAssetUrl = (path) => {
  if (!path || typeof path !== 'string') return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const base = resolveBaseURL();
  // Ensure base ends with '/' and path starts with '/'
  const normalizedBase = base.endsWith('/') ? base : `${base}/`;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}api/announcements${normalizedPath}`;
};

export default httpClientAnnouncements;



